import { render, staticRenderFns } from "./personal-loan-calculator.vue?vue&type=template&id=72c7e72e&scoped=true&lang=pug"
import script from "./personal-loan-calculator.vue?vue&type=script&lang=js"
export * from "./personal-loan-calculator.vue?vue&type=script&lang=js"
import style0 from "./personal-loan-calculator.vue?vue&type=style&index=0&id=72c7e72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7e72e",
  null
  
)

export default component.exports